import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';

@Component({
  selector: 'app-select-program',
  templateUrl: './select-program.page.html',
  styleUrls: ['./select-program.page.scss'],
})
export class SelectProgramPage implements OnInit {

  program: any;
  sltpro: any;
  finalprogram: any;
  programimage: any = [];
  finalid: any;


  constructor(public modalCtrl: ModalController,
    public addCall: AddCall) { }


  ngOnInit() {
    this.sltpro = null;
    console.log(this.program);
    this.finalprogram = null;
  }

  dismiss() {
    this.sltpro = null;
    this.finalprogram = null;
    this.modalCtrl.dismiss({
      selectprogram: null,
    })
  }

  selectprogramFn() {
    this.modalCtrl.dismiss({
      selectprogramname: this.finalprogram,
      selectId: this.finalid
    })
  }


  choosepro(i, item) {
    this.sltpro = i
    this.finalprogram = item.name;
    this.finalid = item.id
    this.modalCtrl.dismiss({
      selectprogramname: this.finalprogram,
      selectId: this.finalid
    })
  }
}
